export function formatNumber(x: number) {
  if (!x && x !== 0) return;
  try {
    if (Number.isInteger(x)) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
      return x
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  } catch (e) {
    return x.toString();
  }
}

export function formatNumberNoDecimals(x: number) {
  return Math.trunc(x)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function convertStringToNumber(number: string) {
  return Number.parseInt(number.replace(/,/g, ''));
}

export function addNumberSuffix(num: number) {
  var j = num % 10,
    k = num % 100;
  if (j === 1 && k !== 11) {
    return num + 'st';
  }
  if (j === 2 && k !== 12) {
    return num + 'nd';
  }
  if (j === 3 && k !== 13) {
    return num + 'rd';
  }
  return num + 'th';
}

export function toWord(num: number) {
  const words = [
    'first',
    'second',
    'third',
    'fourth',
    'fifth',
    'sixth',
    'seventh',
    'eighth',
    'ninth',
    'tenth',
    'eleventh',
    'twelfth',
    'thirteenth',
    'fourteenth',
    'fifteenth',
    'sixteenth',
    'seventeenth',
    'eighteenth',
    'nineteenth',
    'twentieth',
  ];
  if (num === 0) return 'zero';
  if (num > 0 && num <= 20) return words[num - 1];
  if (num > 20) return addNumberSuffix(num);
}
